var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker-city"},[_c('van-picker',{ref:"picker",attrs:{"title":"选择区域","show-toolbar":"","columns":_vm.regionList},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }